import ApplicationController from "./application_controller";
import { FetchRequest } from "@rails/request.js";

export default class extends ApplicationController {
  static targets = [];

  connect() {
    console.log("hi from quickad_controller.js");
  }

  async update(e) {
    e.stopPropagation();
    e.preventDefault();

    console.log("now update status! " + e.target.dataset.status);

    const request = new FetchRequest("patch", "/ads/" + this.element.dataset.adid, {
      body: JSON.stringify({
        ad: {
          validation_status: e.target.dataset.status,
        },
      }),
      contentType: "application/json",
      headers: {
        "Accept": "application/json"
      }
    });
    const response = await request.perform();
    if (response.ok) {
      console.log("did respond ok " + response.text);
      window.location.reload();
    }
  }
}
